<template>
  <div class="price-page">
    <!-- general info card -->
    <b-col md="12">
      <card class="data-card" :show-footer-line="true">
        <b-row no-gutters>
          <b-col class="header-row" no-gutters>
            <div class="card-header mb-4 pb-2">
              <h1 style="margin-left: 16px">ویرایش قیمت ها</h1>
            </div>
          </b-col>
        </b-row>

        <b-row no-gutters>
          <b-col lg="6" sm="12">
            <b-row>
              <b-col no-gutters style="padding-left: 12" sm="9">
                <label class="form-label">قیمت فروش(تتر به تومان)</label>

                <b-skeleton class="mb-4" v-if="!show" type="input"></b-skeleton>
                <b-form-group class="mb-0" v-if="show">
                  <base-input
                    :disabled="!isSuperAdmin"
                    minlength="5"
                    placeholder="قیمت فروش"
                    type="number"
                    class="text-input"
                    :rules="{ required: true, min: 5 }"
                    autofocus
                    name="قیمت فروش"
                    v-model="usdtIrtPrice"
                  ></base-input>
                </b-form-group>
              </b-col>
              <b-col class="pt-4 mt-2">
                <b-skeleton
                  class="submit-skeleton"
                  v-if="!show"
                  type="button"
                  variant="primary"
                ></b-skeleton>
                <b-button
                  v-if="show && isSuperAdmin"
                  @click="setUsdtIrtPrice()"
                  size="md"
                  variant="primary"
                  class="p-2 pl-4 pr-4"
                >
                  ویرایش
                </b-button
                >
              </b-col>
            </b-row>
            <b-row>
              <b-col no-gutters style="padding-left: 12" sm="9">
                <label class="form-label">قیمت خرید(تومان به تتر)</label>

                <b-skeleton class="mb-4" v-if="!show" type="input"></b-skeleton>
                <b-form-group class="mb-0" v-if="show">
                  <base-input
                    :disabled="!isSuperAdmin"
                    placeholder="قیمت خرید"
                    type="number"
                    class="text-input"
                    :rules="{ required: true, min: 5 }"
                    autofocus
                    name="قیمت خرید"
                    v-model="irtUsdtPrice"
                  ></base-input>
                </b-form-group>
              </b-col>
              <b-col class="pt-4 mt-2">
                <b-skeleton
                  class="submit-skeleton"
                  v-if="!show"
                  type="button"
                  variant="primary"
                ></b-skeleton>
                <b-button
                  v-if="show && isSuperAdmin"
                  @click="setIrtUsdtPrice()"
                  size="md"
                  variant="primary"
                  class="p-2 pl-4 pr-4"
                >
                  ویرایش
                </b-button
                >
              </b-col>
            </b-row>
            <b-row>
              <b-col no-gutters style="padding-left: 12" sm="9">
                <label class="form-label"
                >قیمت فروش (پرفکت مانی به تومان)</label
                >
                <b-skeleton class="mb-4" v-if="!show" type="input"></b-skeleton>
                <b-form-group class="mb-0" v-if="show">
                  <base-input
                    :disabled="!isSuperAdmin"
                    placeholder="قیمت خرید"
                    type="number"
                    class="text-input"
                    :rules="{ required: true, min: 2 }"
                    autofocus
                    name="قیمت خرید"
                    v-model="pmIrtPrice"
                  ></base-input>
                </b-form-group>
              </b-col>
              <b-col class="pt-4 mt-2">
                <b-skeleton
                  class="submit-skeleton"
                  v-if="!show"
                  type="button"
                  variant="primary"
                ></b-skeleton>
                <b-button
                  v-if="show && isSuperAdmin"
                  @click="setPmIrtPrice()"
                  size="md"
                  variant="primary"
                  class="p-2 pl-4 pr-4"
                >ویرایش
                </b-button>
              </b-col>
            </b-row>
            <b-row>
              <b-col no-gutters style="padding-left: 12" sm="9">
                <label class="form-label"
                >قیمت خرید (تومان به پرفکت مانی)</label
                >
                <b-skeleton class="mb-4" v-if="!show" type="input"></b-skeleton>
                <b-form-group class="mb-0" v-if="show">
                  <base-input
                    :disabled="!isSuperAdmin"
                    placeholder="قیمت خرید"
                    type="number"
                    class="text-input"
                    :rules="{ required: true, min: 2 }"
                    autofocus
                    name="قیمت خرید"
                    v-model="irtPmPrice"
                  ></base-input>
                </b-form-group>
              </b-col>
              <b-col class="pt-4 mt-2">
                <b-skeleton
                  class="submit-skeleton"
                  v-if="!show"
                  type="button"
                  variant="primary"
                ></b-skeleton>

                <b-button
                  v-if="show && isSuperAdmin"
                  @click="setIrtPmPrice()"
                  size="md"
                  variant="primary"
                  class="p-2 pl-4 pr-4"
                >ویرایش
                </b-button>
              </b-col>
            </b-row>
          </b-col>
          <b-col>
            <b-row>
              <b-col no-gutters style="padding-left: 12" sm="6">
                <label class="form-label">سقف سرویس مرحله 1</label>

                <b-skeleton class="mb-4" v-if="!show" type="input"></b-skeleton>
                <b-form-group class="mb-0" v-if="show">
                  <base-input
                    :disabled="!isSuperAdmin"
                    placeholder="سقف سرویس مرحله 1"
                    type="number"
                    class="text-input"
                    :rules="{ required: true, min: 1, max: 10 }"
                    autofocus
                    name="کارمزد سرویس"
                    v-model="serviceFeeLevel1cap"
                  ></base-input>
                </b-form-group>
              </b-col>
              <b-col no-gutters style="padding-left: 12" sm="6">
                <label class="form-label">کارمزد سرویس مرحله 1</label>

                <b-skeleton class="mb-4" v-if="!show" type="input"></b-skeleton>
                <b-form-group class="mb-0" v-if="show">
                  <base-input
                    :disabled="!isSuperAdmin"
                    placeholder="کارمزد سرویس مرحله 1"
                    type="number"
                    class="text-input"
                    :rules="{ required: true, min: 1, max: 10 }"
                    autofocus
                    name="کارمزد سرویس"
                    v-model="serviceFeeLevel1"
                  ></base-input>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col no-gutters style="padding-left: 12" sm="6">
                <label class="form-label">سقف سرویس مرحله 2</label>

                <b-skeleton class="mb-4" v-if="!show" type="input"></b-skeleton>
                <b-form-group class="mb-0" v-if="show">
                  <base-input
                    :disabled="!isSuperAdmin"
                    placeholder="سقف سرویس مرحله 1"
                    type="number"
                    class="text-input"
                    :rules="{ required: true, min: 1, max: 10 }"
                    autofocus
                    name="کارمزد سرویس"
                    v-model="serviceFeeLevel2cap"
                  ></base-input>
                </b-form-group>
              </b-col>
              <b-col no-gutters style="padding-left: 12" sm="6">
                <label class="form-label">کارمزد سرویس مرحله 2</label>

                <b-skeleton class="mb-4" v-if="!show" type="input"></b-skeleton>
                <b-form-group class="mb-0" v-if="show">
                  <base-input
                    :disabled="!isSuperAdmin"
                    placeholder="کارمزد سرویس مرحله 1"
                    type="number"
                    class="text-input"
                    :rules="{ required: true, min: 1, max: 10 }"
                    autofocus
                    name="کارمزد سرویس"
                    v-model="serviceFeeLevel2"
                  ></base-input>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col no-gutters style="padding-left: 12" sm="6">
                <label class="form-label">سقف سرویس مرحله 3</label>

                <b-skeleton class="mb-4" v-if="!show" type="input"></b-skeleton>
                <b-form-group class="mb-0" v-if="show">
                  <base-input
                    :disabled="!isSuperAdmin"
                    placeholder="سقف سرویس مرحله 1"
                    type="number"
                    class="text-input"
                    :rules="{ required: true, min: 1, max: 10 }"
                    autofocus
                    name="کارمزد سرویس"
                    v-model="serviceFeeLevel3cap"
                  ></base-input>
                </b-form-group>
              </b-col>
              <b-col no-gutters style="padding-left: 12" sm="6">
                <label class="form-label">کارمزد سرویس مرحله 3</label>

                <b-skeleton class="mb-4" v-if="!show" type="input"></b-skeleton>
                <b-form-group class="mb-0" v-if="show">
                  <base-input
                    :disabled="!isSuperAdmin"
                    placeholder="کارمزد سرویس مرحله 1"
                    type="number"
                    class="text-input"
                    :rules="{ required: true, min: 1, max: 10 }"
                    autofocus
                    name="کارمزد سرویس"
                    v-model="serviceFeeLevel3"
                  ></base-input>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col class="">
                <b-skeleton
                  class="submit-skeleton"
                  v-if="!show"
                  type="button"
                  variant="primary"
                ></b-skeleton>
                <b-button
                  v-if="show && isSuperAdmin"
                  @click="setServiceFee()"
                  size="md"
                  variant="primary"
                  class="p-2 pl-4 pr-4"
                >ثبت تنظیمات کارمزد ها
                </b-button
                >
              </b-col>
            </b-row>
          </b-col>
        </b-row>
      </card>
    </b-col>
    <!-- end general info card -->
  </div>
</template>
<script>
import http from "@/httpservices/HttpService"
import store from "@/store"

export default {
  name: "user-info",
  data() {
    return {
      show: false,
      loading: true,

      irtUsdtPrice: "",
      usdtIrtPrice: "",
      pmIrtPrice: "",
      irtPmPrice: "",

      serviceFeeLevel1: "",
      serviceFeeLevel1cap: "",

      serviceFeeLevel2: "",
      serviceFeeLevel2cap: "",

      serviceFeeLevel3: "",
      serviceFeeLevel3cap: "",

      serviceFee: "",
    };
  },
  mounted() {
    this.getConfigs();
  },
  computed: {
    isSuperAdmin() {
      return store.getters['isSuperAdmin']
    }
  },
  methods: {
    getConfigs() {
      this.show = false;


      http.get("/Configs/")
        .then((response) => {
          this.irtUsdtPrice = response.data.irtUsdt;
          this.usdtIrtPrice = response.data.usdtIrt;
          this.pmIrtPrice = response.data.pmIrt;
          this.irtPmPrice = response.data.irtPm;

          this.serviceFeeLevel1cap = response.data.serviceFee[0][0];
          this.serviceFeeLevel1 = response.data.serviceFee[0][1];

          this.serviceFeeLevel2cap = response.data.serviceFee[1][0];
          this.serviceFeeLevel2 = response.data.serviceFee[1][1];

          this.serviceFeeLevel3cap = response.data.serviceFee[2][0];
          this.serviceFeeLevel3 = response.data.serviceFee[2][1];

          this.show = true;
        })
        .catch((err) => {
          this.show = true;
          //console.log(err);
          //this.$router.push("/500");
        });
    },

    setServiceFee() {
      this.show = false;

      // let data = this.serviceFee.toString();
      let data = [
        [this.serviceFeeLevel1cap, this.serviceFeeLevel1],
        [this.serviceFeeLevel2cap, this.serviceFeeLevel2],
        [this.serviceFeeLevel3cap, this.serviceFeeLevel3],
      ];

      this.$store
        .dispatch("setServiceFee", {data})
        .then((res) => {
          this.show = true;

          this.$swal({
            position: "top-end",
            icon: "success",
            title: "هزینه سرویس جدید ثبت شد",
            showConfirmButton: false,
            timer: 3000,
            toast: true,
          });
        })
        .catch((err) => {
          this.show = true;
          this.$swal({
            position: "center",
            icon: "error",
            title: "خطا در ثبت اطلاعات",
            showConfirmButton: false,
            timer: 1500,
          });

          let errorResponse = this.errorHandler(err);
        });
    },

    setIrtUsdtPrice() {
      this.show = false;

      let data = this.irtUsdtPrice.toString();

      this.$store
        .dispatch("setIrtUsdtPrice", {data})
        .then((res) => {
          this.show = true;

          this.$swal({
            position: "top-end",
            icon: "success",
            title: "قیمت جدید ثبت شد",
            showConfirmButton: false,
            timer: 3000,
            toast: true,
          });
        })
        .catch((err) => {
          this.show = true;
          this.$swal({
            position: "center",
            icon: "error",
            title: "خطا در ثبت اطلاعات",
            showConfirmButton: false,
            timer: 1500,
          });

          let errorResponse = this.errorHandler(err);
        });
    },

    setUsdtIrtPrice() {
      this.show = false;

      let data = this.usdtIrtPrice.toString();

      this.$store
        .dispatch("setUsdtIrtPrice", {data})
        .then((res) => {
          this.show = true;

          this.$swal({
            position: "top-end",
            icon: "success",
            title: "قیمت جدید ثبت شد",
            showConfirmButton: false,
            timer: 3000,
            toast: true,
          });
        })
        .catch((err) => {
          this.show = true;
          this.$swal({
            position: "center",
            icon: "error",
            title: "خطا در ثبت اطلاعات",
            showConfirmButton: false,
            timer: 1500,
          });

          let errorResponse = this.errorHandler(err);
        });
    },

    async setPmIrtPrice() {
      this.show = false;
      await http.post("/Configs/pmirt", {
        value: String(this.pmIrtPrice),
      })

      this.$swal({
        position: "top-end",
        icon: "success",
        title: "قیمت جدید ثبت شد",
        showConfirmButton: false,
        timer: 3000,
        toast: true,
      });

      this.show = true;
    },

    async setIrtPmPrice() {
      this.show = false;
      const token = localStorage.getItem("token") || "";

      await http.post("/Configs/irtpm", {
        value: String(this.irtPmPrice),
      },)

      this.$swal({
        position: "top-end",
        icon: "success",
        title: "قیمت جدید ثبت شد",
        showConfirmButton: false,
        timer: 3000,
        toast: true,
      });

      this.show = true;
    },

  },
};
</script>
<style lang="scss" scoped>
.price-page {
  padding-right: 16px;
  padding-left: 24px;
  padding-top: 24px;
  text-align: right;

  .card-header {
    padding: 0;
  }
}
</style>
